import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import Products from './pages/Products';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import ScrollToTop from './components/scrollontop/ScrollOnTop';
import ProductDetail from './pages/ProductDetail';
import { getWatsappNumber } from './services/WatsappNumber';
import { useMediaQueries } from './usecontext/UseProvider';
import PrivateRoutes from './adminComponents/privateroute/PrivateRoute';
import Dashboard from './adminPages/Dashboard';
import LoginPage from './adminPages/LoginPage';
import Sidebar from './adminComponents/sidebar/Sidebar';
import HomeCarosal from './adminPages/HomeCarosal';
import Categories from './adminPages/Categories';
import CategoryFormPage from './adminPages/CategoryFormPage';
import AdminProducts from './adminPages/AdminProducts';
import ProductFormPage from './adminPages/ProductFormPage';
import ViewProduct from './adminPages/ViewProduct';
import SomethingUnique from './adminPages/SomethingUnique';
import AdminAboutUs from './adminPages/AdminAboutUs';
import EditAboutUS from './adminPages/EditAboutUS';
import StoryPerpose from './adminPages/StoryPerpose';
import StoryAndPerposeFormPage from './adminPages/StoryAndPerposeFormPage';
import AboutGallaryPage from './adminPages/AboutGallaryPage';
import HappyCustomerPage from './adminPages/HappyCustomerPage';
import MediaManagerPage from './adminPages/MediaManagerPage';
import ContactUSPage from './adminPages/ContactUSPage';
import ContactUsmodal from './adminPages/ContactUsmodal';

function MainAppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/product" element={<Products />} />
        <Route path="/product/:id" element={<Products />} />
        <Route path="/product-detail/:id" element={<ProductDetail />} />
      </Route>
    </Routes>
  );
}

function AdminRoutes() {
  return (
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route element={<Sidebar />}>
          <Route path="" element={<Dashboard />} />
          <Route path="/home-carosal" element={<HomeCarosal />} />
          <Route path="/manage-store/categories" element={<Categories />} />
          <Route path="/manage-store/categories/add" element={<CategoryFormPage />} />
          <Route path="/manage-store/categories/:id" element={<CategoryFormPage />} />
          <Route path="/manage-store/products" element={<AdminProducts />} />
          <Route path="/manage-store/products/add" element={<ProductFormPage />} />
          <Route path="/manage-store/products/:id" element={<ProductFormPage />} />
          <Route path="/manage-store/products/view/:id" element={<ViewProduct />} />
          <Route path="/manage-store/unique" element={<SomethingUnique />} />
          <Route path="/aboutus" element={<AdminAboutUs />} />
          <Route path="/aboutus/edit" element={<EditAboutUS />} />
          <Route path="/story-perpose" element={<StoryPerpose />} />
          <Route path="/story-perpose/add" element={<StoryAndPerposeFormPage />} />
          <Route path="/story-perpose/:id" element={<StoryAndPerposeFormPage />} />
          <Route path="/about-gallery" element={<AboutGallaryPage />} />
          <Route path="/happy-customer" element={<HappyCustomerPage />} />
          <Route path="/media-manager" element={<MediaManagerPage />} />
          <Route path="/contact" element={<ContactUSPage />} />
          <Route path="/contact/edit" element={<ContactUsmodal />} />
        </Route>
      </Route>
      <Route path="login" element={<LoginPage />} />
    </Routes>
  );
}

// ✅ Move `useLocation()` inside a new component
function AppContent() {
  const { setWpNumber } = useMediaQueries();
  const location = useLocation();

  const getWatsappNumberData = async () => {
    try {
      const response = await getWatsappNumber();
      setWpNumber(response?.watsappNumberData?.watsappNumber);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getWatsappNumberData();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 50,
    });
  }, []);

  useEffect(() => {
    // Set overflow hidden for non-admin routes
    if (!location.pathname.startsWith('/admin')) {
      document.documentElement.style.overflowX = 'hidden';
    } else {
      // Remove the overflow-x property only for admin routes
      delete document.documentElement.style.overflowX;
    }
  }, [location.pathname]);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/*" element={<MainAppRoutes />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;